import ResultatContratMasse from '@/generated/classes/ResultatContratMasse';
import { ControleSignatureMasseQuery as ControleSignatureMasseQueryBase } from '@/generated/classes/ResultatContratMasse';
import { ControleSignatureMasseResult as ControleSignatureMasseResultBase } from '@/generated/classes/ResultatContratMasse';
import { ControleSignatureMasseManque as ControleSignatureMasseManqueBase } from '@/generated/classes/ResultatContratMasse';
import { AppliquerObjetCommunQuery as AppliquerObjetCommunQueryBase } from '@/generated/classes/ResultatContratMasse';
import { AppliquerObjetCommunResult as AppliquerObjetCommunResultBase } from '@/generated/classes/ResultatContratMasse';
import { AppliquerModeleContratQuery as AppliquerModeleContratQueryBase } from '@/generated/classes/ResultatContratMasse';
import { AppliquerModeleContratResult as AppliquerModeleContratResultBase } from '@/generated/classes/ResultatContratMasse';
import { EnvoiSignatureMasseQuery as EnvoiSignatureMasseQueryBase } from '@/generated/classes/ResultatContratMasse';
import { EnvoiSignatureMasseResult as EnvoiSignatureMasseResultBase } from '@/generated/classes/ResultatContratMasse';
export default class ResultatContratMasseExtend extends ResultatContratMasse {
  constructor() {
    super();
  }
}
export class ControleSignatureMasseQuery extends ControleSignatureMasseQueryBase {
  constructor() {
    super();
  }
}
export class ControleSignatureMasseResult extends ControleSignatureMasseResultBase {
  constructor() {
    super();
  }
}
export class ControleSignatureMasseManque extends ControleSignatureMasseManqueBase {
  constructor() {
    super();
  }
}
export class AppliquerObjetCommunQuery extends AppliquerObjetCommunQueryBase {
  constructor() {
    super();
  }
}
export class AppliquerObjetCommunResult extends AppliquerObjetCommunResultBase {
  constructor() {
    super();
  }
}
export class AppliquerModeleContratQuery extends AppliquerModeleContratQueryBase {
  constructor() {
    super();
  }
}
export class AppliquerModeleContratResult extends AppliquerModeleContratResultBase {
  constructor() {
    super();
  }
}
export class EnvoiSignatureMasseQuery extends EnvoiSignatureMasseQueryBase {
  constructor() {
    super();
  }
}
export class EnvoiSignatureMasseResult extends EnvoiSignatureMasseResultBase {
  constructor() {
    super();
  }
}
